// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Annual-module__description--Wfo9A,\n.Annual-module__pagination--MBYP0 {\n  margin-top: 24px;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/OpeningInfo/components/Annual/Annual.module.less"],"names":[],"mappings":"AAAA;;EAEE,gBAAA;AACF","sourcesContent":[".description,\n.pagination {\n  margin-top: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": "Annual-module__description--Wfo9A",
	"pagination": "Annual-module__pagination--MBYP0"
};
export default ___CSS_LOADER_EXPORT___;
